import { Item } from '@radix-ui/react-context-menu'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

export interface ContextMenuItemProps extends ComponentPropsWithoutRef<
  typeof Item
> {
  asChild?: boolean
  disabled?: boolean
  onSelect?: (event: Event) => void
  textValue?: string
  inset?: boolean
  /**
   * [data-highlighted] - Present when highlighted
   * [data-disabled] - Present when disabled
   */
  className?: string
}

export const ContextMenuItem = forwardRef<
  ElementRef<typeof Item>,
  ContextMenuItemProps
>(({ className, inset, ...delegated }, ref) => (
  <Item
    ref={ref}
    className={cn(
      'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      inset && 'pl-8',
      className
    )}
    {...delegated}
  />
))
ContextMenuItem.displayName = Item.displayName
